export default "__VITE_ASSET__c4aP5sdd__"